// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3AtSf","label":"Labeled_label__3f7IP","divider":"Labeled_divider__2Smlw"};